import axios from 'axios'
import { message } from 'antd'

const PriceApi = axios.create({
  baseURL: process.env.REACT_APP_PRICE_API_ENDPOINT,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
})

PriceApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('user-token')
  if (token) {
    config.headers.Authorization = token
  }
  return config
})

PriceApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error && error.response && error.response.status
    if (status === 401) {
      message.error('กรุณาเข้าสู่ระบบใหม่')
    } else if (status === 403) {
      message.error('สิทธิ์ Admin ไม่ถูกต้อง')
    }
    return Promise.reject(error)
  }
)

export default PriceApi
